import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'

const OverviewTabSkeleton: React.FC = () => (
  <div className="space-y-4">
    <div className="flex items-center gap-3 py-2">
      <Skeleton className="h-8 w-52" />
      <Skeleton className="ml-auto h-8 w-24" />
    </div>
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {[0, 1, 2, 3].map((i) => <Skeleton key={i} className="h-24 w-full" />)}
    </div>
    <Skeleton className="h-[330px] w-full" />
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
      <Skeleton className="h-40 w-full" />
      <Skeleton className="h-40 w-full" />
    </div>
  </div>
)
export default OverviewTabSkeleton
